module.exports = __webpack_public_path__ + "img/Aston_University1.b98213b9.jpg";